<template>
  <div class="lot-card d-flex justify-content-between w-100">
    <div
      class="d-flex flex-column flex-md-row align-items-md-center gap-1 w-100"
    >
      <div class="text-semibold mb-0 fs-14">{{ lot.name }}</div>
      <div class="divider d-none d-md-block" />
      <span class="text-green">R$ {{ formatMoney(lot.price) }}</span>
      <div class="divider d-none d-md-block" />
      <div class="d-flex align-items-center gap-1 mr-3 mb-0">
        <bp-tooltip
          size="14"
          text="Ingresso por lote, atrelado ao final da venda de outro ingresso"
          :disabled="!lot.parent_id"
        >
          <bp-icon class="text-dark" icon="ph ph-ticket" />
        </bp-tooltip>
        <span class="functional-1 text-neutral-400">{{ lot.stock }}</span>
      </div>
      <div
        class="d-flex flex-column flex-md-row text-neutral-400 functional-1 mb-0"
      >
        <div v-if="lot.start_at">
          <span class="d-md-none">Início: </span>
          {{ formatDate(lot.start_at) }}
        </div>
        <div v-if="lot.start_at" class="d-none d-md-inline mx-1">-</div>
        <div>
          <span class="d-md-none">Término: </span>
          {{ formatDate(lot.end_at) }}
        </div>
      </div>
    </div>

    <div class="d-flex gap-3">
      <snow-button text="Editar" variant="gray" @click="$emit('edit')" />
      <snow-button
        v-if="!hasChildren"
        text="Excluir"
        variant="danger"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>
<script>
import { formatMoney } from "@/functions/helpers";
import moment from "moment";
export default {
  props: {
    lot: {
      type: Object,
      default: () => ({})
    },
    hasChildren: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({ isMobile: window.innerWidth < 992 }),
  methods: {
    formatMoney,
    formatDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    }
  }
};
</script>
<style lang="scss" scoped>
.lot-card {
  background-color: white;
  border-radius: 16px;
  width: 100%;
  padding: 16px;
  gap: 4px;

  .divider {
    width: 1px;
    height: 20px;
    background-color: var(--dark-10);
    margin: 0 8px;
  }
}
</style>
